import Axios from "axios";

export class EmpleadoAcDirService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/editar`, data).then(res => res.data);
    }

    consultar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/consulta/${id}`, { params: opciones }).then(res => res.data);
    }

    descargar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/reporte/${id}`, {            
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache', 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Expires': 0 },
            params: { t: new Date().getTime(), ...opciones },
            responseType: 'blob'
        }).then(async res => res.data);
    }

    listadoAdjuntos(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/listado?${queryParams}`).then(res => res.data);
    }

    store(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/store`, data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => res.data);
    }

    descargaAdjunto(id, idp) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/descarga/${id}/${idp}`, {
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' },
            responseType: 'blob'
        }).then(async res => res.data);
    }

    eliminarAnexo(id, idp) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/eliminar-anexo/${id}/${idp}`).then(res => res.data);
    }

    enviar(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/enviar`, data).then(res => res.data);
    }

    eliminar(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/eliminar/${id}`).then(res => res.data);
    }

    aprobar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/empleado-ac-dir/aprobar`, data).then(res => res.data);
    }
}
